import { postSse } from './ssePost'

export function runBacktestSse(payload, { signal, onEvent } = {}) {
  return postSse('/api/v1/backtest/run', payload, { signal, onEvent })
}
